import React, { useEffect, useRef } from "react";

const InteriorParallax = ({ imgArr }) => {
  const intRef = useRef(null);
  const canvasRef = useRef(null);
  const imgRef = useRef(null);
  const frameCount = useRef(imgArr?.length || 0);

  useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");

    const resizeCanvas = () => {
      canvas.width = canvas.clientWidth;
      canvas.height = canvas.clientHeight;
    };

    const draw = () => {
      resizeCanvas();
      const loaded = imgRef.current;
      if (!loaded) return;
      const iw = loaded.width;
      const ih = loaded.height;
      const cw = canvas.width;
      const ch = canvas.height;
      const f = Math.min(cw / iw, ch / ih);
      context.clearRect(0, 0, cw, ch);
      context.drawImage(
        loaded,
        0,
        0,
        iw,
        ih,
        (cw - f * iw) / 2,
        (ch - f * ih) / 2,
        f * iw,
        f * ih
      );
    };

    const updateImage = (index) => {
      const loaded = new Image();
      loaded.src = imgArr[Math.min(Math.ceil(index), frameCount.current - 1)];
      loaded.onload = () => {
        imgRef.current = loaded;
        draw();
      };
    };

    const scrollFunc = () => {
      const containerBoundingClientRect =
        intRef.current?.parentNode.getBoundingClientRect();
      if (!containerBoundingClientRect) return;
      const scrollPercent = Math.max(
        Math.min(
          -containerBoundingClientRect.top /
            (containerBoundingClientRect.height - window.innerHeight),
          1
        ),
        0
      );
      const targetTime = scrollPercent * (frameCount.current - 1);
      updateImage(targetTime);
    };

    const debouncedScrollFunc = debounce(scrollFunc, 100); // Debounce scroll event

    window.addEventListener("scroll", debouncedScrollFunc);
    return () => {
      window.removeEventListener("scroll", debouncedScrollFunc);
    };
  }, [imgArr]);

  const debounce = (func, delay) => {
    let timeoutId;
    return function (...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func.apply(this, args), delay);
    };
  };

  return (
    <div style={{ height: "800vh", position: "relative" }} ref={intRef}>
      <div className="top-[30px] mx-auto sticky h-screen w-full">
        <canvas
          ref={canvasRef}
          className="absolute top-[50%] left-[50%] w-full h-full"
          style={{ transform: "translate(-50%, -50%)" }}
          height={1080}
          width={1920}
          id="interior-parallax"
        />
      </div>
    </div>
  );
};

export default InteriorParallax;
